import request from "@/utils/http"; // 导入http中创建的axios实例

// 添加下级门店
export function create(data) {
  return request.post("/merchant/child/create", data);
}

// 获取下级门店
export function child() {
  return request.get(`/merchant/child`);
}
